"use strict";

import {tutils, PropTypes, resolvers} from "Subschema";
const {resolveKey} = tutils;

function handleErrorListeners(value, key, props, {valueManager}) {
	const resolvedPath = resolveKey(props.path, value);
	let errors = valueManager.errorsFor(resolvedPath);

	//no matter what we will show errors at this point
	if (errors) {
		this.injected[key] = errors;
	} else {
		this.injected[key] = null;
	}

	return valueManager.addErrorListener(resolvedPath, (err)=> {

		this.injected[key] = err;
		this.mounted && this.forceUpdate();
	}, this, /**false so it doesn't override*/false).remove;
}

export default function notif(Clazz, key) {
	Clazz.contextTypes.valueManager = PropTypes.valueManager;
	Clazz::this.listener(key, handleErrorListeners);

}


/** WEBPACK FOOTER **
 ** ./src/resolver/notif.js
 **/